import React, { useEffect } from 'react'
import { logout } from '../features/auth/authSlice'
import { userProfile } from '../features/auth/authAction'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import style from './Products.module.css'

const Products = () => {
  const { loggedUserInfo } = useSelector((state) => state.auth)
  const loggedDetails = useSelector((state) => state.auth.loggedDetails)
  const dispatch = useDispatch()


useEffect(() => {
  // dispatch(userProfile());
}, [dispatch]);

  const loggedInUserName = loggedUserInfo !== undefined ? loggedUserInfo.user.name : '';

  return (
    <header>
      <div className={style.headerStatus}>
        <span>
          {loggedUserInfo ? `Logged in as ${loggedInUserName}`
              : "You're not logged in"}
        </span>
        <div className='cta'>
          {loggedDetails ? (
            <button className='button' onClick={() => dispatch(logout())}>
              Logout
            </button>
          ) : (
            <NavLink className='button' to='/login'>
              Login
            </NavLink>
          )}
        </div>
      </div>
      <nav className='container navigation'>
        <NavLink to='/'>Home</NavLink>
        <NavLink to='/login'>Login</NavLink>
        <NavLink to='/register'>Register</NavLink>
        <NavLink to='/user-profile'>Profile</NavLink>
      </nav>
    </header>
  )
}
export default Products